export default __webpack_public_path__ + "static/hongKong-835994b29f152bb104789263e8579f5b.svg";